<template>
  <div v-if="isReady">
    <invoice-detail
      v-if="localId"
      :show="show"
      :id="localId"
      @close="close"
    />
    <invoice-create
      v-else
      :show="show"
      :entity="entity"
      :total-amount="totalAmount"
      :iss-rate="issRate"
      :ir-rate="irRate"
      :pis-rate="pisRate"
      :cofins-rate="cofinsRate"
      :csll-rate="csllRate"
      :inss-rate="inssRate"
      :origin-type="originType"
      :origin-id="originId"
      @close="close"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import InvoiceCreate from './FiscalDocumentCreate.vue';
import InvoiceDetail from './FiscalDocumentDetail.vue';

export default {
  components: {
    InvoiceCreate,
    InvoiceDetail,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    entity: {
      type: Object,
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
    issRate: {
      type: Number,
      default: 0,
    },
    irRate: {
      type: Number,
      default: 0,
    },
    pisRate: {
      type: Number,
      default: 0,
    },
    cofinsRate: {
      type: Number,
      default: 0,
    },
    csllRate: {
      type: Number,
      default: 0,
    },
    inssRate: {
      type: Number,
      default: 0,
    },
    originType: {
      type: String,
    },
    originId: {
      type: String,
    },
  },
  data() {
    return {
      ready: false,
      loading: false,
      localId: null,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState({
      branch: ({ auth }) => auth.user.branch,
    }),
    settings() {
      return this.branch.settings.fiscalDocument;
    },
    isEnabled() {
      return this.settings && this.settings.enabled;
    },
    isReady() {
      return this.ready && !this.loading;
    },
    origin() {
      if (!this.originId || !this.originType) return null;
      return [this.originType, this.originId].join(':');
    },
  },
  methods: {
    async init() {
      if (this.id) {
        this.localId = this.id;
      } else if (this.origin) {
        this.localId = await this.findIdByOrigin();
      }
      this.ready = true;
    },
    async findIdByOrigin() {
      this.setLoading(true);

      try {
        const params = {
          limit: 1,
          origin: this.origin,
        };
        const { data } = await this.$http.get('/fiscal-documents', { params });

        if (data.items.length > 0) {
          return data.items[0].id;
        }
      } catch (e) {
        this.$toast.error(e);
      } finally {
        this.setLoading(false);
      }

      return null;
    },
    setLoading(value) {
      this.loading = value;
      this.$emit('loading', this.loading);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
